<div mat-dialog-title>
  <span>{{ 'TOOLBAR.PRINT' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content class="content">
  <q9-info-message class="modal-info-message">
    {{ 'POPUPS.PRINT_DIALOG' | translate }}
  </q9-info-message>
  <form [formGroup]="form" class="form-content">
    <mat-radio-group formControlName="radio" class="orientation">
      <span>{{ 'POPUPS.ORIENT' | translate }}</span>
      <mat-radio-button color="primary" [disableRipple]="true" value="portrait">
        {{ 'POPUPS.PORTRAIT' | translate }}
      </mat-radio-button>
      <mat-radio-button color="primary" [disableRipple]="true" value="landscape">
        {{ 'POPUPS.LANDSCAPE' | translate }}
      </mat-radio-button>
    </mat-radio-group>

    <mat-checkbox color="primary" [disableRipple]="true" formControlName="addNames">
      {{ 'POPUPS.PRINT_NAMES' | translate }}
    </mat-checkbox>

    <mat-checkbox *ngIf="!isPro" color="primary" [disabled]="true">
      {{ 'POPUPS.REMOVE_WATER' | translate }}
    </mat-checkbox>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button (click)="confirm()">
    {{ 'POPUPS.PRINT_BTN' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
